import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import useClick from '../../../../hooks/useClick';
import palette from '../../../styles/palette';

const useStyles = makeStyles(() => ({
  section: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    background: palette.typography.white.neutral,
    padding: '0.625rem',
  },
  active: {
    background: palette.liteGreen,
  },
  content: {
    width: '15.625rem',
    marginLeft: '0.5rem',
  },
  header: {
    color: 'white',
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
  },
  title: {
    color: 'white',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  },
  spot: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '0.125rem',
  },
}));

const SectionCardBase = ({
  spot,
  children,
  active,
  onDoubleClick,
  onClick,
  ...props
}) => {
  const styles = useStyles();
  const click = useClick(onClick, onDoubleClick);

  return (
    <Box
      className={clsx(styles.section, active && styles.active)}
      onClick={click}
    >
      <Box className={styles.spot} style={{ background: spot }} />
      <Box className={styles.content}>
        <Typography className={styles.header} data-testid="section-name">
          {props.sectionName}
        </Typography>
        <Typography className={styles.title} data-testid="shift-manager-name">
          {props.shiftManagerName}
        </Typography>
        {children}
      </Box>
    </Box>
  );
};

export default SectionCardBase;
